import request from "@/utils/request";
import "@/utils/global.js";

export default {
  // 新闻列表
  newsList(param) {
    return request({
      url: `/official/news/all/page`,
      method: "get",
      params: param
    });
  },
  //置顶新闻
  topNewsList(param) {
    return request({
      url: `/official/news/top/all`,
      method: "get",
      params: param
    });
  },
  // 新闻详情
  newsDetail(param) {
    return request({
      url: `/official/news/` + param.nid + `/details`,
      method: "get",
      params: param
    });
  },
  // 案例列表
  casesList(param) {
    return request({
      url: `https://document.daspatial.com/api_v1_unauth/user/getDasCasesList/`,
      method: "get",
      params: param
    });
  },
  // 案例详情
  casesDetail(param) {
    return request({
      url: `https://document.daspatial.com/api_v1_unauth/user/getDasCasesList/`,
      method: "get",
      params: param
    });
  },
  // 视频列表
  videolist(param) {
    return request({
      url: `https://document.daspatial.com/api_v1_unauth/user/getDasVideoList/`,
      method: "get",
      params: param
    });
  },
  // 视频详情
  videoDetail(param) {
    return request({
      url: `https://document.daspatial.com/api_v1_unauth/user/getDasVideoDetail/`,
      method: "get",
      params: param
    });
  },
  // 登陆
  login(param) {
    return request({
      url: `auth/oauth/token`,
      method: "post",
      params: param
    });
  },
  // 获取验证码
  getCode(param) {
    return request({
      url: `admin/code/send`,
      method: "post",
      params: param
    });
  },
  // 验证码登陆
  loginByCode(param) {
    return request({
      url: `auth/oauth/token`,
      // url: `auth/mobile/token/social`,
      method: "post",
      params: param
    });
  },
  // 用户信息
  getUserInfo(param) {
    return request({
      url: `admin/user/info`,
      method: "get",
      params: param
    });
  },
  // 编辑用户信息
  upateUserInfo(param) {
    return request({
      url: `admin/user/update`,
      method: "post",
      params: param
    });
  },
  // 更换密码
  resetPass(param) {
    return request({
      url: `admin/user/resetPassword`,
      method: "post",
      params: param
    });
  },
  // 注册
  regist(param) {
    return request({
      url: `admin/user`,
      method: "post",
      params: param
    });
  },
  // 获取应用id
  getAppidByCode(param) {
    return request({
      url: `official/app/id`,
      method: "get",
      params: param
    });
  },
  // 试用详情
  getTrial(param) {
    return request({
      url: `official/trial`,
      method: "get",
      params: param
    });
  },
  // 试用延期/购买
  delayTrial(param) {
    return request({
      url: `official/action/` + param.trialId + `/delay`,
      method: "post",
      params: param
    });
  },
  // 应用详情
  getAppDetail(param) {
    // todo:不需要登录信息
    param["notoken"] = true;
    return request({
      url: `official/app/info`,
      method: "get",
      params: param
    });
  },
  // 工程列表
  getProjectList(param) {
    return request({
      url: `rebuild/project/page`,
      method: "get",
      params: param
    });
  },
  // 工程照片总数
  getPhotoNum(param) {
    return request({
      url: `rebuild/photo/count`,
      method: "get",
      params: param
    });
  },
  // 最后一个任务详情
  getlastTaskDetail(param) {
    return request({
      url: `rebuild/task/latest`,
      method: "get",
      params: param
    });
  },
  // 重启任务
  reStartTask(param) {
    return request({
      url: `rebuild/task/` + param.taskId + `/start`,
      method: "post",
      params: param
    });
  },
  logOut(param) {
    return request({
      url: `auth/token/logout`,
      method: "delete",
      params: param
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/user.js